var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"MobileBanner"}},[_c('el-carousel',{staticStyle:{"width":"100vw"},attrs:{"height":"250px"}},_vm._l((_vm.imgArr.length),function(item){return _c('el-carousel-item',{key:item},[_c('h3',{staticClass:"small"},[_c('img',{staticClass:"MImgArr",attrs:{"src":_vm.imgArr[item - 1],"alt":""}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }